function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "51.2,59.5 7.8,59.5 7.8,4.4 17.1,4.4 17.1,7.4 10.8,7.4 10.8,56.5 48.2,56.5 48.2,7.4 41.8,7.4 41.8,4.4  51.2,4.4  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 23.1,
  y: 16.4,
  width: 19.7,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 16.2,
  y: 16.4,
  width: 3.9,
  height: 3
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 23.1,
  y: 24.4,
  width: 19.7,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 16.2,
  y: 24.4,
  width: 3.9,
  height: 3
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 23.1,
  y: 32.5,
  width: 19.7,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 16.2,
  y: 32.5,
  width: 3.9,
  height: 3
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 23.1,
  y: 40.5,
  width: 19.7,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 16.2,
  y: 40.5,
  width: 3.9,
  height: 3
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 23.1,
  y: 48.5,
  width: 19.7,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 16.2,
  y: 48.5,
  width: 3.9,
  height: 3
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M43.4,11.4H15.6V0.5h27.8V11.4z M18.6,8.4h21.8V3.5H18.6V8.4z"
})))));

var SvgList = function SvgList(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/list.842787af.svg";
export { SvgList as ReactComponent };